import { FC } from 'react'
import { useOnEvent } from 'utils'
import { ShareInfoFragment } from 'gqlTypes'

interface LatestShareVersionSubscribeProps {
  onVersionUpdate: (share: ShareInfoFragment) => void
  shareID: string
}

export const useLatestShareVersionSubscribe = ({
  onVersionUpdate,
  shareID,
}: LatestShareVersionSubscribeProps) => {
  useOnEvent('shareWillBeUploaded', share => {
    if (share.identifier !== shareID) {
      return
    }
    onVersionUpdate(share)
  })
}

const LatestShareVersionSubscribe: FC<LatestShareVersionSubscribeProps> = props => {
  useLatestShareVersionSubscribe(props)
  return null
}

export default LatestShareVersionSubscribe
